module.exports = __webpack_public_path__ + "img/gd-sharepoint-pc.3141d939.png";